module.exports = __webpack_public_path__ + "static/mikko_kotola_ja_panu_vartiainen-a12d35578dbb548001d4d5b7be393b8b.jpg";